"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoicesGetSharedRequestCategory = void 0;
exports.VoicesGetSharedRequestCategory = {
    Professional: "professional",
    Famous: "famous",
    HighQuality: "high_quality",
};
